import { render, staticRenderFns } from "./CampaignStatusTable.vue?vue&type=template&id=9e618ce6&scoped=true"
import script from "./CampaignStatusTable.vue?vue&type=script&lang=js"
export * from "./CampaignStatusTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignStatusTable.vue?vue&type=style&index=0&id=9e618ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e618ce6",
  null
  
)

export default component.exports